<template>
  <el-dialog title="视频文件选择" @close="close" width="80%" class="newlyadd">
    <el-form class="head">
      <el-form-item label="视频来源">
        <el-select v-model="value" class="m-2" placeholder="不限">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="录像发生时间">
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          :shortcuts="shortcuts"
          range-separator="~"
          start-placeholder="开始"
          end-placeholder="结束"
        />
      </el-form-item>
      <el-form-item class="right">
        <el-input
          v-model="input1"
          class="w-50 m-2"
          placeholder="文件名称/录像地点"
          :suffix-icon="Search"
        />
      </el-form-item>
    </el-form>
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="fileslist"
      :params="tableParams"
      class="table"
      @select="hzTableSelect"
    >
      <template #role="{ row }">
        <div class="table-role" @click="clickTable(row)">
          <span>{{ row.name }}</span>
        </div>
      </template>
    </h-table>
    <div class="btn">
      <!-- <h-button type="primary" @click="qbSelect">全部选择</h-button> -->
      <h-button type="primary" @click="uploading">确定</h-button>
      <h-button type="danger" @click="clone()">取消</h-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  computed,
  ref,
} from "vue";
import { Search } from "@element-plus/icons-vue";
import { fileslist } from "@/api/videoAnalysis/videoAnalysisApi.js";
export default defineComponent({
  name: "",
  components: { Search },
  props: {},
  setup(props, context) {
    const state = reactive({
      tableData: [],
      columns: [
        {
          type: "selection",
        },
        {
          type: "index",
        },
        {
          label: "文件名称",
          prop: "fileName",
        },
        {
          label: "状态",
          slot: "state",
        },
        {
          label: "视频来源",
          slot: "fileSource",
        },
        {
          label: "录像地点",
          slot: "location",
        },
        {
          label: "录像发生时间",
          slot: "startTime",
        },
        {
          label: "创建人",
          prop: "creator",
        },
      ],
      tableParams: {
        uploadStatus: 0,
      },
      selectList: [],
    });
    const tableRef = ref(null);
    const hzTableSelect = (val) => {
      state.selectList = val;
    };
    const uploading = (val) => {
      context.emit("selectList", state.selectList);
    };
    const clone = (val) => {
      context.emit("clone");
    };
    // const qbSelect = val => {
    //   context.emit("clone");
    // };

    return {
      ...toRefs(state),
      clone,
      hzTableSelect,
      uploading,
      tableRef,
      fileslist,
    };
  },
});
</script>

<style lang="scss" scoped>
.el-form {
  display: flex;
  .el-form-item {
    margin: 0 5px;
  }
  .el-input {
    margin-left: 495px;
  }
}
.btn {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.table {
  height: 500px;
}
</style>
